// extracted by mini-css-extract-plugin
export default {"link":"style_link__lAdEE","centerGrid":"style_centerGrid__+s6xV","img":"style_img__8UWce","namegame":"style_namegame__UzaBs","center":"style_center__cBnNe"};